// extracted by mini-css-extract-plugin
module.exports = {"grouping_count":"index_grouping_count_3XLlC","right":"index_right_1jgew"};